import { useEffect } from 'react'
import { useTranslation } from 'next-i18next'

import Vibeke from '~/assets/vibeke'
import Lightbulb from '~/assets/icons/lightbulb'
import Rocket from '~/assets/icons/rocket'
import ScalesOfJustice from '~/assets/icons/scales-of-justice'
import BrainHeart from '~/assets/icons/brain-heart'

export function About(): React.ReactElement {
  const { t } = useTranslation('about')
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div className="mt-16 px-4 sm:px-24 xl:px-64 pb-16">
      <div className="mx-auto max-w-3xl relative bg-white rounded-small xl:rounded shadow-experimental">
        <Header bgColor="bg-purple" icon={Lightbulb} main position="left" text={t('title')} />
        <p className="p-6 pt-8 sm:p-8 sm:pt-10 xl:p-16 xl:pt-20 whitespace-pre-line text-about lg:text-about-large text-gray-sub-text">
          {t('titleText')}
        </p>
      </div>
      <div className="mt-24" />
      <div className="mx-auto max-w-3xl relative bg-white rounded-small xl:rounded shadow-experimental">
        <Header bgColor="bg-orange-medium" icon={Rocket} position="right" text={t('history')} />
        <div className="flex flex-col sm:flex-row-reverse">
          <p className="m-auto px-6 p-8 sm:pt-10 xl:p-16 xl:pt-20 text-menu xl:text-h3 leading-8 xl:leading-10">
            {t('vibeke')}
          </p>
          <img
            alt="Vibeke Gwendoline Fængsrud"
            className="w-1/2 sm:w-1/3 md:h-intrinsic sm:mt-10 sm:ml-8 xl:mt-20 xl:ml-16 mx-auto rounded-small xl:rounded"
            src={Vibeke}
          />
        </div>
        <p className="p-6 pt-8 sm:p-8 sm:pt-6 xl:p-16 xl:pt-8 whitespace-pre-line text-about xl:text-about-large text-gray-sub-text">
          {t('historyText')}
        </p>
      </div>
      <div className="mt-24" />
      <div className="mx-auto max-w-3xl relative bg-white rounded-small xl:rounded shadow-experimental">
        <Header bgColor="bg-blue-primary" icon={ScalesOfJustice} position="left" text={t('approach')} />
        <p className="p-6 pt-8 sm:p-8 sm:pt-10 xl:p-16 xl:pt-20 whitespace-pre-line text-about xl:text-about-large text-gray-sub-text">
          {t('approachText')}
        </p>
      </div>
      <div className="mt-24" />
      <div className="mx-auto max-w-3xl relative bg-white rounded-small xl:rounded shadow-experimental">
        <Header bgColor="bg-pink" icon={BrainHeart} position="right" text={t('values')} />
        <p className="p-6 pt-8 sm:p-8 sm:pt-10 xl:p-16 xl:pt-20 whitespace-pre-line text-about xl:text-about-large text-gray-sub-text">
          {t('valuesText')}
        </p>
      </div>
    </div>
  )
}

function Header({
  bgColor,
  icon,
  main,
  position,
  text,
}: {
  bgColor: string
  icon: string
  main?: boolean
  position: 'left' | 'right' | 'center'
  text: string
}): React.ReactElement {
  let positionClassName

  switch (position) {
    case 'left':
      positionClassName = 'ml-6 xl:ml-16'
      break

    case 'right':
      positionClassName = 'right-0 mr-6 xl:mr-16'
      break

    case 'center':
      positionClassName = 'left-1/2 -translate-x-1/2 whitespace-nowrap'
      break

    default:
      break
  }

  return (
    <header
      className={
        'absolute transform -translate-y-1/2 ' +
        `${positionClassName} ` +
        'px-4 py-1 sm:px-6 sm:py-2 xl:px-12 xl:py-4 ' +
        'inline-flex items-center rounded-small xl:rounded ' +
        `${bgColor} font-semibold xl:font-semibold text-menu xl:text-h3 text-white`
      }
    >
      <img alt={text} className="h-6 lg:h-full mr-2 lg:mr-4" src={icon} />
      {main ? <h1>{text}</h1> : <h2>{text}</h2>}
    </header>
  )
}
